import { type Common } from './common.js';
import type * as Visit from './models/visit.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async fetchAllInpatient(options: {
    practiceId: string;
    providerTeamId?: string | null;
    active?: boolean | null;
  }): Promise<Visit.DisplayableInpatientVisit[]> {
    const url = this.common.constructPath(`/visits`, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<Visit.Visit> {
    const url = this.common.constructPath(`/visits/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: Visit.CreateValues): Promise<Visit.Visit> {
    const url = this.common.constructPath(`/visits`);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: Visit.UpdateValues): Promise<Visit.Visit> {
    const url = this.common.constructPath(`/visits/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`/visits/${id}`);
    return await this.common.deleteJSON(url);
  }
}
